import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.from";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.splice";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";
import _classCallCheck from "/home/dastan/Work/www/oopt-front/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/dastan/Work/www/oopt-front/node_modules/@babel/runtime/helpers/esm/createClass";

/**
 * @license Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module engine/view/documentfragment
 */
import Text from './text';
import TextProxy from './textproxy';
import mix from '@ckeditor/ckeditor5-utils/src/mix';
import isIterable from '@ckeditor/ckeditor5-utils/src/isiterable';
import EmitterMixin from '@ckeditor/ckeditor5-utils/src/emittermixin';
/**
 * Document fragment.
 *
 * To create a new document fragment instance use the
 * {@link module:engine/view/upcastwriter~UpcastWriter#createDocumentFragment `UpcastWriter#createDocumentFragment()`}
 * method.
 */

var DocumentFragment = /*#__PURE__*/function () {
  /**
   * Creates new DocumentFragment instance.
   *
   * @protected
   * @param {module:engine/view/document~Document} document The document to which this document fragment belongs.
   * @param {module:engine/view/node~Node|Iterable.<module:engine/view/node~Node>} [children]
   * A list of nodes to be inserted into the created document fragment.
   */
  function DocumentFragment(document, children) {
    _classCallCheck(this, DocumentFragment);

    /**
     * The document to which this document fragment belongs.
     *
     * @readonly
     * @member {module:engine/view/document~Document}
     */
    this.document = document;
    /**
     * Array of child nodes.
     *
     * @protected
     * @member {Array.<module:engine/view/element~Element>} module:engine/view/documentfragment~DocumentFragment#_children
     */

    this._children = [];

    if (children) {
      this._insertChild(0, children);
    }
  }
  /**
   * Iterable interface.
   *
   * Iterates over nodes added to this document fragment.
   *
   * @returns {Iterable.<module:engine/view/node~Node>}
   */


  _createClass(DocumentFragment, [{
    key: Symbol.iterator,
    value: function value() {
      return this._children[Symbol.iterator]();
    }
    /**
     * Number of child nodes in this document fragment.
     *
     * @readonly
     * @type {Number}
     */

  }, {
    key: "is",

    /**
     * Checks whether this object is of the given type.
     *
     *		docFrag.is( 'documentFragment' ); // -> true
     *		docFrag.is( 'view:documentFragment' ); // -> true
     *
     *		docFrag.is( 'model:documentFragment' ); // -> false
     *		docFrag.is( 'element' ); // -> false
     *		docFrag.is( 'node' ); // -> false
     *
     * {@link module:engine/view/node~Node#is Check the entire list of view objects} which implement the `is()` method.
     *
     * @param {String} type
     * @returns {Boolean}
     */
    value: function is(type) {
      return type == 'documentFragment' || type == 'view:documentFragment';
    }
    /**
     * {@link module:engine/view/documentfragment~DocumentFragment#_insertChild Insert} a child node or a list of child nodes at the end
     * and sets the parent of these nodes to this fragment.
     *
     * @param {module:engine/view/item~Item|Iterable.<module:engine/view/item~Item>} items Items to be inserted.
     * @returns {Number} Number of appended nodes.
     */

  }, {
    key: "_appendChild",
    value: function _appendChild(items) {
      return this._insertChild(this.childCount, items);
    }
    /**
     * Gets child at the given index.
     *
     * @param {Number} index Index of child.
     * @returns {module:engine/view/node~Node} Child node.
     */

  }, {
    key: "getChild",
    value: function getChild(index) {
      return this._children[index];
    }
    /**
     * Gets index of the given child node. Returns `-1` if child node is not found.
     *
     * @param {module:engine/view/node~Node} node Child node.
     * @returns {Number} Index of the child node.
     */

  }, {
    key: "getChildIndex",
    value: function getChildIndex(node) {
      return this._children.indexOf(node);
    }
    /**
     * Gets child nodes iterator.
     *
     * @returns {Iterable.<module:engine/view/node~Node>} Child nodes iterator.
     */

  }, {
    key: "getChildren",
    value: function getChildren() {
      return this._children[Symbol.iterator]();
    }
    /**
     * Inserts a child node or a list of child nodes on the given index and sets the parent of these nodes to
     * this fragment.
     *
     * @param {Number} index Position where nodes should be inserted.
     * @param {module:engine/view/item~Item|Iterable.<module:engine/view/item~Item>} items Items to be inserted.
     * @returns {Number} Number of inserted nodes.
     */

  }, {
    key: "_insertChild",
    value: function _insertChild(index, items) {
      this._fireChange('children', this);

      var count = 0;
      var nodes = normalize(this.document, items);
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = nodes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var node = _step.value;

          // If node that is being added to this element is already inside another element, first remove it from the old parent.
          if (node.parent !== null) {
            node._remove();
          }

          node.parent = this;

          this._children.splice(index, 0, node);

          index++;
          count++;
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return count;
    }
    /**
     * Removes number of child nodes starting at the given index and set the parent of these nodes to `null`.
     *
     * @param {Number} index Number of the first node to remove.
     * @param {Number} [howMany=1] Number of nodes to remove.
     * @returns {Array.<module:engine/view/node~Node>} The array of removed nodes.
     */

  }, {
    key: "_removeChildren",
    value: function _removeChildren(index) {
      var howMany = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

      this._fireChange('children', this);

      for (var i = index; i < index + howMany; i++) {
        this._children[i].parent = null;
      }

      return this._children.splice(index, howMany);
    }
    /**
     * Fires `change` event with given type of the change.
     *
     * @private
     * @param {module:engine/view/document~ChangeType} type Type of the change.
     * @param {module:engine/view/node~Node} node Changed node.
     * @fires module:engine/view/node~Node#change
     */

  }, {
    key: "_fireChange",
    value: function _fireChange(type, node) {
      this.fire('change:' + type, node);
    } // @if CK_DEBUG_ENGINE // printTree() {
    // @if CK_DEBUG_ENGINE //	let string = 'ViewDocumentFragment: [';
    // @if CK_DEBUG_ENGINE //	for ( const child of this.getChildren() ) {
    // @if CK_DEBUG_ENGINE //		if ( child.is( 'text' ) ) {
    // @if CK_DEBUG_ENGINE //			string += '\n' + '\t'.repeat( 1 ) + child.data;
    // @if CK_DEBUG_ENGINE //		} else {
    // @if CK_DEBUG_ENGINE //			string += '\n' + child.printTree( 1 );
    // @if CK_DEBUG_ENGINE //		}
    // @if CK_DEBUG_ENGINE //	}
    // @if CK_DEBUG_ENGINE //	string += '\n]';
    // @if CK_DEBUG_ENGINE //	return string;
    // @if CK_DEBUG_ENGINE // }
    // @if CK_DEBUG_ENGINE // logTree() {
    // @if CK_DEBUG_ENGINE // 	console.log( this.printTree() );
    // @if CK_DEBUG_ENGINE // }

  }, {
    key: "childCount",
    get: function get() {
      return this._children.length;
    }
    /**
     * Is `true` if there are no nodes inside this document fragment, `false` otherwise.
     *
     * @readonly
     * @type {Boolean}
     */

  }, {
    key: "isEmpty",
    get: function get() {
      return this.childCount === 0;
    }
    /**
     * Artificial root of `DocumentFragment`. Returns itself. Added for compatibility reasons.
     *
     * @readonly
     * @type {module:engine/model/documentfragment~DocumentFragment}
     */

  }, {
    key: "root",
    get: function get() {
      return this;
    }
    /**
     * Artificial parent of `DocumentFragment`. Returns `null`. Added for compatibility reasons.
     *
     * @readonly
     * @type {null}
     */

  }, {
    key: "parent",
    get: function get() {
      return null;
    }
  }]);

  return DocumentFragment;
}();

export { DocumentFragment as default };
mix(DocumentFragment, EmitterMixin); // Converts strings to Text and non-iterables to arrays.
//
// @param {String|module:engine/view/item~Item|Iterable.<String|module:engine/view/item~Item>}
// @returns {Iterable.<module:engine/view/node~Node>}

function normalize(document, nodes) {
  // Separate condition because string is iterable.
  if (typeof nodes == 'string') {
    return [new Text(document, nodes)];
  }

  if (!isIterable(nodes)) {
    nodes = [nodes];
  } // Array.from to enable .map() on non-arrays.


  return Array.from(nodes).map(function (node) {
    if (typeof node == 'string') {
      return new Text(document, node);
    }

    if (node instanceof TextProxy) {
      return new Text(document, node.data);
    }

    return node;
  });
}